<template>
  <div>
    <h2 class="vb-heading h5">Pernotto e servizi</h2> 
    <div v-for="(hotel, hotel_index) in hotels_info" :key="`${hotel}:${hotel_index}`">
      <div class="vb-hotels">
        <div class="vb-hotels__wrap">
          <div class="vb-hotels__item">
            <vb-icon
              class="vb-hotels__item-icon"
              :name="'hotel'"
              :size="25"
              :color="sass('gray-400')"
            />
            <span class="vb-hotels__item-text" v-html="hotel.name"></span>
          </div>
          <div class="vb-hotels__item">
            <span>IN {{ reverse_date(hotel.checkIn) }}</span>
            <vb-icon
              class="vb-hotels__item-icon vb-hotels__item-icon--check"
              :name="'arrow-r'"
              :size="25"
              :color="sass('gray-400')"
            />
            <span>OUT {{ reverse_date(hotel.checkOut) }}</span>
          </div>

          <div class="vb-hotels__wrap">
            <div class="vb-hotels__item">
              <vb-icon
                class="vb-hotels__item-icon"
                :name="'bed'"
                :size="25"
                :color="sass('gray-400')"
              />
              <span v-html="room_parsed.label"></span>
            </div>
            <div class="vb-hotels__item">
              <vb-icon
                class="vb-hotels__item-icon"
                :name="'cutlery'"
                :size="25"
                :color="sass('gray-400')"
              />
              <span v-html="room_parsed.treatment.label"></span>
            </div>
            <div class="vb-hotels__item">
              <vb-icon
                class="vb-hotels__item-icon"
                :name="'bus'"
                :size="25"
                :color="sass('gray-400')"
              />
              <span class="text-uppercase">Trasferimenti *</span>
            </div>
            <div class="vb-hotels__item" v-b-modal="'insurance'">
              <vb-icon
                class="vb-hotels__item-icon"
                :name="'shield'"
                :size="25"
                :color="sass('gray-400')"
              />
              <span class="text-uppercase">Assicurazione</span>
              <vb-icon
                class="ml-1"
                :name="'info'"
                :color="sass('gray-500')"
                :size="14"
              />
            </div>
            <vb-modal
              :vb_options="{
                id: 'insurance',
                size: 'lg',
                title: 'I pacchetti viaggio includono',
                hide_footer: true,
              }"
            >
              <services-insurance class="p-0 mt-0" />
            </vb-modal>
          </div>
        </div>
        <div
          class="vb-hotels__service"
          v-if="!supplements.every((suppl) => !suppl.visible)"
        >
          <vb-toggle
            :vb_options="{
              id: `service:${hotel_index}`,
              btn_text: 'Servizi inclusi nel pacchetto',
            }"
          >
            <ul>
              <li
                v-for="(suppl, suppl_index) in supplements.filter(
                  (suppl) => suppl.visible,
                )"
                :key="`${suppl}:${suppl_index}`"
              >
                {{ suppl.name.toLowerCase() }}
              </li>
            </ul>
          </vb-toggle>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reverse_date } from "@utilities/commons";
import ServicesInsurance from "@alpitour/components/blocks/detail/assicurazione-medico-bagaglio.vue";
export default {
  name: "hotels",

  props: {
    hotels: Array,
    supplements: {
      type: Array,
      default: () => [],
    },
  },

  components: {
    "services-insurance": ServicesInsurance,
  },

  created() {
    this.reverse_date = reverse_date;
  },

  computed: {
    hotels_info() {
      return this.hotels.map(hotel => ({
        name: hotel.name || hotel.hotel_name || '',
        checkIn: hotel.checkIn || hotel.checkin || '',
        checkOut: hotel.checkOut || hotel.checkout || '',
      }))
    },
    room_parsed() {
      const first = this.hotels && this.hotels[0]
      if (!first) return { label: '', treatment: { label: '' } }

      if (first.offers) {
        let result = { label: '', treatment: { label: '' } }
        this.hotels.forEach(hotel => {
          hotel.offers.forEach(offer => {
            offer.rooms.forEach(room => {
              room.boards.forEach(board => {
                if (board.selected) {
                  result = {
                    id: room.id,
                    label: room.name,
                    price: parseFloat(room.priceDescriptor.netPrice) + parseFloat(board.totalPrice),
                    treatment: {
                      id: board.id,
                      label: board.description,
                      totalPrice: board.totalPrice,
                    },
                  }
                }
              })
            })
          })
        })
        return result
      }

      // Flat sololand shape — room/board can be plain strings or nested objects
      const room = first.room || {}
      if (typeof room === 'string') {
        return {
          id: room,
          label: room,
          price: 0,
          treatment: {
            id: first.board || '',
            label: first.board || '',
            totalPrice: '0',
          },
        }
      }
      const rate = room.rate || {}
      const pricing = rate.pricing || {}
      return {
        id: room.name || '',
        label: room.name || '',
        price: pricing.total || 0,
        treatment: {
          id: rate.description || '',
          label: rate.description || '',
          totalPrice: '0',
        },
      }
    },
  },
};
</script>

<style lang="scss">
.vb-hotels {
  padding-top: $grid-gutter-width/2;

  &__wrap {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  &__item {
    display: flex;
    align-items: center;
    margin-right: $grid-gutter-width/2;
    margin-bottom: $grid-gutter-width/4;

    &-icon {
      margin-right: $grid-gutter-width/5;

      &--check {
        margin-left: $grid-gutter-width/5;
      }
    }
  }

  &__service {
    margin-top: $grid-gutter-width;
    width: 100%;

    @include media-breakpoint-up(lg) {
      width: 40%;
    }

    .vb-toggle {
      padding: 0;
    }

    li {
      list-style: circle;
    }
  }
}
</style>
